export enum StatusDetalheImportacaoMovimentacaoCadastral {
  Erro,
  Ok,
}
